import { push } from 'connected-react-router';
import { paths } from '../../../routes/paths';
import CoreAPIService from '../../../utils/core-api';
import UserUtils, { AccountRole } from '../../../utils/userUtils';
import { fetchAction } from '../../actions';
import { IDRole, User } from '../api-types';
import Cookies from 'js-cookie';
import envConfig from '../../../config';
import { TOKEN_RENEW_THRESHOLD } from '../../../utils/constants';
export type { User };

export const name: string = 'login';

const config = require(`../../../config/${process.env.NODE_ENV}.json`);

//=============================================//
//=============== Actions Types ===============//
//=============================================//

export const types = {
    LOGIN: name + '/LOGIN',
    LOGIN_ID: name + '/LOGIN_ID',
    GET_USER: name + '/GET_USER',
    EDIT_USER: name + '/EDIT_USER',
    EDIT_PASSWORD: name + '/EDIT_PASSWORD',
    RESET_PASSWORD: name + '/RESET_PASSWORD',
    ERROR_GOTO_LOGIN: name + '/ERROR_GOTO_LOGIN',
    REDIRECT_TO_ID: name + '/REDIRECT_TO_ID',
    LOGOUT: name + '/LOGOUT',
    LOGOUT_BO: name + '/LOGOUT_BO',
    LOGOUT_ID: name + '/LOGOUT_ID',
    RENEW_TOKEN: name + '/RENEW_TOKEN',
    CLEAR_ERROR: name + '/CLEAR_ERROR',
};

interface LoginState {
    user: User;
    loginError: {};
}

const initialState: LoginState = {
    user: {} as User,
    loginError: {},
};

const extractRights = (roles: IDRole[]) => {
    const res = {};
    roles.forEach((role) => {
        if (role.rights?.length > 0) {
            role.rights.forEach((right) => {
                const grant = right.grant;
                const val = res[right.tag];
                if (grant) {
                    if (!val || val === 'R') {
                        res[right.tag] = grant;
                    }
                }
            });
        }
    });
    return res;
};

const reducer = (state = initialState, action) => {
    const payload = action.payload;
    // const parameters = action.parameters;
    switch (action.type) {
        case types.LOGIN:
            UserUtils.setUser(payload);
            return state;
        case types.LOGIN_ID:
            // const token = parameters?.token ?? '';
            const admin = payload.core.find((u) => u.class === 'admin');
            const operator = payload.core.find((u) => u.class === 'operator');
            const viadialog = payload.telephony?.find((t) => t.provider === 'viadialog');
            payload.access_token = (admin?.token || operator?.token) ?? '';
            payload.user = {
                email: payload?.emails?.[0]?.email,
                firstname: payload?.firstname,
                id: admin?.id ?? operator?.id,
                lastname: payload?.lastname,
                type: admin?.class ?? operator?.class,
                agent: viadialog,
            };
            payload.rights = extractRights(payload.roles);
            // console.log(payload);
            UserUtils.setUser(payload);
            return state;
        case types.REDIRECT_TO_ID:
            const queryString = window.location.search;
            const originString = window.location.origin;
            const urlParams = new URLSearchParams(queryString);
            const redirect = urlParams.get('redirect');
            window.location.href = `${envConfig.id_url}${redirect ? `?redirect=${originString}${redirect}` : ''}`;
            return state;
        case types.LOGOUT:
        case types.LOGOUT_ID:
            UserUtils.removeUser();
            UserUtils.removeFreeSeatingInfos();
            return state;
        case types.LOGOUT_BO:
            UserUtils.removeUser();
            UserUtils.removeFreeSeatingInfos();
            const anchor = document.createElement('a');
            anchor.href = `${envConfig.id_url}`;
            anchor.referrerPolicy = 'no-referrer';
            anchor.click();
            return state;
        case types.GET_USER:
            return {
                ...state,
                user: payload,
            };
        case types.EDIT_USER:
            const user = UserUtils.getUser();
            user.user = Object.assign(user.user, payload);
            UserUtils.setUser(user);
            return {
                ...state,
                user: payload,
            };
        case types.EDIT_PASSWORD:
            return state;
        case types.ERROR_GOTO_LOGIN:
            // payload.error.message = i18n.t("common:disconnected");
            return {
                ...state,
                loginError: payload,
            };
        case types.CLEAR_ERROR:
            return {
                ...state,
                loginError: {},
            };
        case types.RENEW_TOKEN:
            return state;
        default:
            return state;
    }
};
export default reducer;

//===========================================//
//=============== Token Renew ===============//
//===========================================//

let renewTimer: NodeJS.Timeout | null = null;

const scheduleRenew = (dispatch: any) => {
    clearTimeout(renewTimer);
    try {
        const token = Cookies.get('token');
        // console.log('scheduleRenew', token);
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expiresAt = payload.exp * 1000;
        // console.log('Token expires at', new Date(expiresAt));
        const delay = expiresAt - Date.now() - TOKEN_RENEW_THRESHOLD;
        if (delay > 0) {
            renewTimer = setTimeout(() => dispatch(actions.renewToken()), delay);
        } else {
            console.warn('Token is already expired or about to expire, renewing now');
            dispatch(actions.renewToken());
        }
    } catch (e) {
        console.error('Failed to decode token for renewal', e);
    }
};

export { scheduleRenew };

//================================================//
//=============== Actions Creators ===============//
//================================================//

export const actions = {
    renewToken: () =>
        fetchAction(
            CoreAPIService.get(`/auth/renew`, null, { credential: true }, envConfig.id_url),
            types.RENEW_TOKEN,
            {},
            {
                success: (dispatch, response) => {
                    scheduleRenew(dispatch);
                },
                error: (dispatch, response) => {
                    console.error('Token renewal failed', response);
                    dispatch(actions.logoutID());
                },
            },
        ),
    scheduleRenewAction: () => (dispatch: any) => scheduleRenew(dispatch),
    login: (id: string, mdp: string) =>
        fetchAction(
            CoreAPIService.post(`/core/auth/authorize`, {
                user_id: id,
                user_password: mdp,
                client_id: '1536954782',
                client_secret: '24OGCoKbkmTVtUZ2yVXvGje6Af9nV7nY',
            }),
            types.LOGIN,
            {},
            {
                success: (dispatch, response) => {
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);
                    const redirect = urlParams.get('redirect');

                    dispatch(push(redirect ?? paths.home));
                },
            },
        ),
    loginID: (token, error?) =>
        fetchAction(
            CoreAPIService.get(`/auth/me`, null, { credential: true }, envConfig.id_url),
            types.LOGIN_ID,
            { token },
            {
                success: (dispatch, response) => {
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);
                    const redirect = urlParams.get('redirect');
                    if (response?.payload?.core?.length > 0) {
                        if (!response.payload?.apps?.find((app) => app.tag === 'bo')) {
                            error('loginID.no_right_app');
                            UserUtils.removeUser();
                            return;
                        }
                        if (
                            !response.payload?.roles?.find(
                                (role) => role.name === AccountRole.Intern || role.name === AccountRole.God,
                            )
                        ) {
                            error('loginID.no_right_role');
                            UserUtils.removeUser();
                            return;
                        }
                        dispatch(push(redirect ?? paths.home));
                        scheduleRenew(dispatch);
                    } else {
                        if (error) {
                            error('loginID.no_user');
                        } else {
                            alert('No user, please contact your admin');
                        }
                        UserUtils.removeUser();
                    }
                },
                error: (dispatch, response) => {
                    if (error) {
                        if (response.key === 'forbidden') {
                            error('common:disconnected');
                        } else {
                            error('Error ' + JSON.stringify(response));
                        }
                    } else {
                        console.error(response);
                    }
                },
            },
        ),
    redirectToID: () => ({ type: types.REDIRECT_TO_ID }),
    getUser: (id) => fetchAction(CoreAPIService.get(`/core/users/${id}`), types.GET_USER, {}),
    editUser: (id: number, email: string, firstname: string, lastname: string, phone_number: string) =>
        fetchAction(
            CoreAPIService.put(
                encodeURI(
                    `/core/users/${id}?$email=${email}&firstname=${firstname}&lastname=${lastname}&phone_number=${phone_number}`,
                ),
                { id },
            ),
            types.EDIT_USER,
            {},
            {
                success: (dispatch) => {
                    dispatch(push(paths.home));
                },
            },
        ),
    editPassword: (id, oldPass, newPass) =>
        fetchAction(
            CoreAPIService.put(encodeURI(`/core/users/${id}?current_password=${oldPass}&password=${newPass}`), { id }),
            types.EDIT_PASSWORD,
            {},
            {
                success: (dispatch) => {
                    dispatch(push(paths.home));
                },
            },
        ),
    resetPassword: (email, callback) =>
        fetchAction(
            CoreAPIService.post(`/core/auth/authorize`, {
                client_id: '1536954782',
                client_secret: '24OGCoKbkmTVtUZ2yVXvGje6Af9nV7nY',
            }),
            types.LOGIN,
            {},
            {
                success: (dispatch, response) => {
                    const { access_token, expires_at } = response.payload;

                    dispatch(
                        fetchAction(
                            CoreAPIService.post(encodeURI(`/core/password_reset`), {
                                email,
                                access_token,
                                expires_at,
                            }),
                            types.RESET_PASSWORD,
                            {},
                            {
                                success: callback,
                            },
                        ),
                    );
                },
            },
        ),
    logout: () => {
        clearTimeout(renewTimer);
        renewTimer = null;
        return fetchAction(
            CoreAPIService.delete(`/core/auth/token`),
            types.LOGOUT,
            {},
            {
                success: (dispatch) => {
                    dispatch(push(paths.login));
                },
                error: (dispatch, error) => {
                    if (error?.payload) {
                        window.alert(
                            `Logout error: ${error.payload.error}.${' Problème lors de la déconnexion. Veuillez réessayer dans quelques instants. Si le problème persiste rendez vous sur la page de login directement (/login)'}`,
                        );
                    }
                },
            },
        );
    },
    logoutID: () => {
        clearTimeout(renewTimer);
        renewTimer = null;
        return fetchAction(
            CoreAPIService.get(`/auth/logout`, null, { credential: true }, envConfig.id_url),
            types.LOGOUT_ID,
            {},
            {
                success: () => {
                    window.location.href = `${envConfig.id_url}`;
                },
            },
        );
    },
    logoutBO: () => {
        clearTimeout(renewTimer);
        renewTimer = null;
        return { type: types.LOGOUT_BO, payload: {} };
    },
    clearError: () => ({ type: types.CLEAR_ERROR, payload: {} }),
};

const localState = (state: any): LoginState => state[name] || initialState;
export const selectors = {
    getUser: (state) => localState(state).user,
    loginError: (state) => localState(state).loginError,
};
